module.exports = __webpack_public_path__ + "img/cashbuddy.9aa6a77.png";